import React from "react";
import styled from "styled-components";
import { Typography } from "@shared/ui/Typography";
import { ProductBenefit } from "@entities/Product/ProductBenefits/ui";
import { motion } from "framer-motion";
import { IBenefit } from "@shared/types";
import { useTranslation } from "next-i18next";

interface IProps {
  benefits: IBenefit[];
}

export function ProductBenefits({ benefits }: IProps) {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.2 }}
    >
      <StyledTitle tag="h2" fontSize="4rem" weight={700}>
        {t(`Преимущества`)}
      </StyledTitle>
      <StyledBenefits>
        {benefits.map((benefit) => (
          <ProductBenefit
            key={benefit.id}
            title={benefit.title}
            subtitle={benefit.description}
            iconName={benefit.icon}
          />
        ))}
      </StyledBenefits>
    </motion.div>
  );
}

const StyledBenefits = styled.div`
  display: grid;
  grid-column-gap: 3.2rem;
  grid-row-gap: 2.4rem;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    grid-template-columns: 1fr;
    grid-gap: 6.4rem;
  }
`;

const StyledTitle = styled(Typography)`
  margin-bottom: 4.3rem;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    margin-bottom: 4rem;
  }
`;
